import { render } from "./g-modal-slide.vue?vue&type=template&id=595f3449&ts=true"
import script from "./g-modal-slide.vue?vue&type=script&lang=tsx"
export * from "./g-modal-slide.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__